import PageLayout from '../components/layout/PageLayout'
import FloatingFabs from '@astro/floating-fabs'
import FaqHeroSection from '../components/sections/faq/FaqHeroSection'
import FaqSection from '../components/sections/faq/FaqSection'
import ProductsCtaSection from '../components/sections/faq/ProductsCtaSection'
import NewsletterSection from '../components/sections/newsletter/NewsletterSection'

export default function FaqPage() {
  return (
    <PageLayout className="bg-[#403c3d]/5 text-[#151b21] antialiased min-h-screen flex flex-col">
      <main className="grow">
        <FaqHeroSection />
        <FaqSection />
        <ProductsCtaSection />
        {/* <NewsletterSection /> */}
      </main>
      <FloatingFabs />
    </PageLayout>
  )
}
